import type { NewsCard } from '@/features/publicsite/types/NewsCard';

const RELATED_COUNT = 3;

/**
 * Which stories to offer under the one being read: the same category first, then the most recent
 * of the rest, never the story itself and never one twice.
 *
 * "Similar" is the category because it is the only thing the platform knows two stories share —
 * there are no tags and no topic model. A story with no category, or a category with fewer than
 * three other stories, is filled from the latest, so the section is full rather than half empty.
 */
export function pickRelated(
  currentSlug: string,
  sameCategory: NewsCard[],
  latest: NewsCard[],
  count = RELATED_COUNT,
): NewsCard[] {
  const seen = new Set([currentSlug]);
  const picked: NewsCard[] = [];
  for (const card of [...sameCategory, ...latest]) {
    if (picked.length === count) break;
    if (seen.has(card.slug)) continue;
    seen.add(card.slug);
    picked.push(card);
  }
  return picked;
}

/**
 * Whether the same category leaves the row short, so the latest have to fill it. Only then are they
 * asked for: a story whose category has three others needs one request, not the two it always made.
 */
export function needsLatest(
  currentSlug: string,
  sameCategory: NewsCard[],
  count = RELATED_COUNT,
): boolean {
  return pickRelated(currentSlug, sameCategory, [], count).length < count;
}
